import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';

/**
 * Off by default: the list in data/recentPurchases.ts is sample data.
 * Set to true once it is fed by real orders.
 */
const ENABLED = false;
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5500;
const GAP_MS = 12000;
export function PurchaseNotifications() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (!ENABLED || dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timeout = setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        show();
      }, GAP_MS);
    };
    timeout = setTimeout(show, FIRST_DELAY);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  if (!ENABLED || dismissed) return null;
  const purchase = recentPurchases[index];
  const minutes = 2 + index * 7 % 26;
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-213" data-mp="evfdaodx7y6p">
      <AnimatePresence data-id="element-214" data-mp="1ci4l5evb150h">
        {visible && <motion.div key={index} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[320px] max-w-full items-start gap-3 rounded-2xl bg-white p-3.5 shadow-card ring-1 ring-paper-dark" data-id="element-215" data-mp="1cgthrg5rtz9w">
            <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-teal-soft" data-id="element-216" data-mp="3jbqagbw2x6n1">
              <CheckIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-217" data-mp="3ppvrnqpkblrj" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-218" data-mp="3asmycrgp87x6">
              <p className="text-[13px] leading-snug text-navy" data-id="element-219" data-mp="3arlcrt224317">
                <span className="font-semibold" data-id="element-220" data-mp="3frg0xoug6eik">{purchase.name}</span> in {purchase.city}, {purchase.state} just got Sailing Lesson Ready
              </p>
              <p className="mt-1 text-[11px] font-semibold text-navy-muted" data-id="element-221" data-mp="31z04j6w1xeqm">{minutes} minutes ago</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="-mr-1 -mt-1 flex h-7 w-7 flex-none items-center justify-center rounded-full text-navy-muted transition-colors duration-150 hover:bg-paper hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-222" data-mp="36suli2k9vfm0">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="24eqii4micf2s" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}